import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@adsk/alloy-react-avatar';
import { useRelativeDate } from '@adsk/alloy-react-datetime';
import { useLocale } from '@adsk/alloy-react-locale';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';
import { getTooltipDate } from './helpers';
import { CommentText } from './layout';
/**
 * A CommentCard component which displays the user which created the comment, it's avatar,
 * and the date it was submitted.
 */
var CommentCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    style = _ref.style,
    user = _ref.user,
    _ref$renderCommentTex = _ref.renderCommentText,
    renderCommentText = _ref$renderCommentTex === void 0 ? function (p) {
      return /*#__PURE__*/React.createElement(CommentText, p);
    } : _ref$renderCommentTex,
    comment = _ref.comment,
    date = _ref.date,
    startDate = _ref.startDate;
  var _useLocale = useLocale(function (_ref2) {
      var locale = _ref2.locale;
      return require("./i18n/".concat(locale, ".json"));
    }),
    T = _useLocale.T;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: ref,
    className: className,
    $_css: [{
      border: "1px solid ".concat(theme.colors.charcoal200),
      borderRadius: theme.borderRadius.medium,
      backgroundColor: theme.colors.white
    }, style]
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [theme.typography.caption, {
      backgroundColor: theme.colors.charcoal050,
      color: theme.colors.charcoal900,
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing.xSmall,
      borderTopRightRadius: '4px',
      borderTopLeftRadius: '4px'
    }]
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: Avatar.SIZES.SMALL_16,
    name: user.name,
    image: user.imageUrl,
    color: Avatar.COLORS.COLOR_3
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: theme.spacing.xxSmall
    }
  }, user.name)), /*#__PURE__*/React.createElement(Tooltip, {
    content: getTooltipDate(date, T)
  }, useRelativeDate(date, startDate))), renderCommentText({
    comment: comment
  }));
});
CommentCard.displayName = 'CommentCard';
CommentCard.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The comment's user */
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string
  }).isRequired,
  /** Render custom comment text. Props ({ comment }) **/
  renderCommentText: PropTypes.func,
  /** The comment text **/
  comment: PropTypes.string.isRequired,
  /** The date of the comment **/
  date: PropTypes.instanceOf(Date).isRequired,
  /** Sets different start date to compare date to **/
  startDate: PropTypes.instanceOf(Date)
};
export default CommentCard;
var _StyledDiv = _styled("div").withConfig({
  displayName: "CommentCard___StyledDiv",
  componentId: "sc-9xxne9-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "CommentCard___StyledDiv2",
  componentId: "sc-9xxne9-1"
})(["", ""], function (p) {
  return p.$_css2;
});
//# sourceMappingURL=CommentCard.js.map